<template>
	<div id="pc">
		
		<!-- 下面 -->
		<div class="botBox pt35 pb15 b484848 cw">
			<div class="bot df dfsa w1k2 mauto">
				<!-- 左边列表 -->
				<div class="botLinks">
					<div class="botLinkTitle mb20 f18 b">关于云程</div>
					<ul>
						<li v-for="(item,index) in about" :key="index" @click="link(item.to)">{{item.name}}</li>
					</ul>
				</div>
				<div class="botLinks">
					<div class="botLinkTitle mb20 f18 b">药企业务</div>
					<ul>
						<li v-for="(item,index) in medicine" :key="index" @click="link(item.to)">{{item.name}}</li>
					</ul>
				</div>
				<div class="botLinks">
					<div class="botLinkTitle mb20 f18 b">政府业务</div>
					<ul>
						<li v-for="(item,index) in government" :key="index" @click="link(item.to)">{{item.name}}</li>
					</ul>
				</div>
				<div class="botLinks">
					<div class="botLinkTitle mb20 f18 b">医院业务</div>
					<ul>
						<li v-for="(item,index) in hospital" :key="index" @click="link(item.to)">{{item.name}}</li>
					</ul>
				</div>
				<div class="botLinks">
					<div class="botLinkTitle mb20 f18 b">合作客户案例</div>
					<ul>
						<li v-for="(item,index) in cases" :key="index" @click="link(item.to)">{{item.name}}</li>
					</ul>
				</div>
				<div class="botLinks">
					<div class="botLinkTitle mb20 f18 b">新闻中心</div>
					<ul>
						<li v-for="(item,index) in news" :key="index" @click="link(item.to)">{{item.name}}</li>
					</ul>
				</div>
				<!-- 右边详情 -->
				<div class="botDetails df aic">
					<!-- 二维码 -->
					<div class="botDetailsQr dit pr tac p10 br5">
						<div class="botDetailsQrImg">
							<img style="width: 100%;" src="../assets/qr.png">
						</div>
						<div class="botDetailsQrTxt mt5 f12 c000">扫一扫联系我们</div>
					</div>
					<!-- 文字区 -->
					<div class="botDetailsTxt ml20 f16">
						<div class="botDetailsTxtList df">
							<div class="botDetailsTxtListL">地址：</div>
							<div class="botDetailsTxtListR f1">山东省济南市槐荫区经七路568号新泉城大厦</div>
						</div>
						<div class="botDetailsTxtList df mt10">
							<div class="botDetailsTxtListL">电话：</div>
							<div class="botDetailsTxtListR f1">0531-88689279</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 页脚 -->
		<div class="foot ptb15 tac f14 cw b202020">Copyright &copy; 2020   版权所有：云程科技网版权所有   网站备案：<a style="color:white" href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">浙ICP备2024095067号</a></div>
		
	</div>
</template>
<script>
	// 全局变量
	var that;
	export default{
		// 页面变量
		data() {
			return {
				// 关键字
				keywords: '',
				// 关于云程
				about: [
					{
						// 名字
						name: '企业介绍',
						// 链接
						to: 'http://www.yuncheng-group.com/list-aboutUs.html',
					},
					{
						// 名字
						name: '企业文化',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Culture.html',
					},
					{
						// 名字
						name: '发展历程',
						// 链接
						to: 'http://www.yuncheng-group.com/list-History.html',
					},
					{
						// 名字
						name: '企业荣誉',
						// 链接
						to: 'http://www.yuncheng-group.com/list-honor.html',
					},
					{
						// 名字
						name: '管理团队',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Team.html',
					},
				],
				// 药企业务
				medicine: [
					{
						// 名字
						name: '主数据管理',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Master.html',
					},
					{
						// 名字
						name: '渠道流向管理',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Channel.html',
					},
					{
						// 名字
						name: '辖区管理',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Jurisdiction.html',
					},
				],
				// 政府业务
				government: [
					{
						// 名字
						name: '主数据管理',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Master.html',
					},
					{
						// 名字
						name: '渠道流向管理',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Channel.html',
					},
					{
						// 名字
						name: '辖区管理',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Jurisdiction.html',
					},
				],
				// 医院
				hospital: [
					{
						// 名字
						name: '慈光健康',
						// 链接
						to: 'http://www.yuncheng-group.com/list-CiguangHealth.html',
					},
				],
				// 合作客户案例
				cases: [
					{
						// 名字
						name: '合作客户',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Customer.html',
					},
					{
						// 名字
						name: '服务案例',
						// 链接
						to: 'http://www.yuncheng-group.com/list-Case.html',
					},
				],
				// 新闻中心
				news: [
					{
						// 名字
						name: '公司新闻',
						// 链接
						to: 'http://www.yuncheng-group.com/list-CompanyNews.html',
					},
					{
						// 名字
						name: '行业新闻',
						// 链接
						to: 'http://www.yuncheng-group.com/list-xingyexinwen.html',
					},
				],
				
				
			}
		},
		
		// 实例化后
		created() {
			that = this;
		},
		
		// 方法集
		methods:{
			// 跳转
			link(url){
				location.href = url;
			},
		},
	};
</script>
<style>
	/* 底部盒子 */
	/* 链接标题 */
	.botLinkTitle {
		cursor: default;
		transition: .5s;
	}
	/* 链接标题鼠标悬停 */
	.botLinkTitle:hover {
		color: #018cd5;
	}
	/* 链接列表链接 */
	.botLinks ul li {
		/* margin-bottom: 5px; */
		line-height: 25px;
		font-size: 14px;
		cursor: pointer;
		transition: .5s;
	}
	/* 链接列表链接 */
	.botLinks ul li:hover {
		color: #018cd5;
	}
	/* 底部详情 */
	.botDetails {
		margin-left: 100px;
	}
	/* 底部详情二维码 */
	.botDetailsQr {
		background-color: #ffffffcc;
	}
	/* 底部联系二维码 */
	.botDetailsQrImg {
		width: 100px;
	}
	/* 底部详情文字 */
	.botDetailsTxt {
		width: 280px;
		line-height: 25px;
	}
</style>